import { useState, useContext, useRef, useEffect } from 'react';
import { useHistory } from "react-router-dom";

// STYLES
import classes from './HomePage.module.scss';

// IMAGES
import bgimg from '../assets/MovieTriviaBG.jpg';
import imgBollywood from '../assets/Bollywood.jpg';
import imgHollywood from '../assets/Hollywood.jpg';

// COMPONENTS
import UserContext from '../store/user-context';
import TriviaContext from '../store/trivia-context';

import MovieCategoryOption from '../components/ui/MovieCategoryOption';
import Button from '../components/ui/Button';
import Modal from '../components/layout/Modal';
import Prompt from '../components/ui/Prompt';
import Loading from '../components/layout/Loading';

function HomePage() {
    const triviaCtx = useContext(TriviaContext);
    const userCtx = useContext(UserContext);

    const [isLoading, setIsLoading] = useState(true);

    const [selectedMovieType, setSelectedMovieType] = useState();
    const [showModal, setShowModal] = useState();
    const inputUsernameEl = useRef(null);
    const inputEmailEl = useRef(null);
    const history = useHistory();

    useEffect(() => {
        const user = {
            username: localStorage.getItem('username'),
            email: localStorage.getItem('email')
        }
        if (user.username && user.email) {
            userCtx.setUser(user);
            userCtx.getUserRecord();
        }

        const loadingTimer = setTimeout(() => {
            if (isLoading) {
                setIsLoading(false);
            }
            clearTimeout(loadingTimer);
        }, 4000);
        return () => {
            setIsLoading(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    const optionChangeHandler = (event) => {
        setSelectedMovieType(event.target.value);
    }

    const submitHandler = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!selectedMovieType) {
            setShowModal(true);
            return;
        }

        const user = {
            username: inputUsernameEl.current.value,
            email: inputEmailEl.current.value
        }
        
        await userCtx.setUser(user);

        // store in local storage
        localStorage.setItem('username', user.username);
        localStorage.setItem('email', user.email);

        triviaCtx.resetTriviaStatus();
        triviaCtx.setMovieCategory(selectedMovieType);

        userCtx.getUserRecord();

        history.push("/TriviaPage");
        setIsLoading(false);
    }

    const hideModalHandler = () => {
        setShowModal(false);
    }

    const imageLoaded = () => {
        setIsLoading(false);
    }

    const gotoLeaderboardHandler = () => {
        history.push('Leaderboard');
    }

    return (
        <div className={classes.home}>
            { isLoading && <Loading />}

            <figure className={classes['home__backdrop']}>
                <img src={bgimg} className={classes['home__backdrop--img']} alt="movie trivia backdrop" onLoad={imageLoaded} />
            </figure>

            <form className={classes['homeform']} onSubmit={submitHandler}>
                <div className={classes['homeform__options']}>
                    <MovieCategoryOption onChange={optionChangeHandler} displayImg={imgBollywood} id={'option1'} value={'Bollywood'} />
                    <MovieCategoryOption onChange={optionChangeHandler} displayImg={imgHollywood} id={'option2'} value={'Hollywood'} />
                </div>

                <div className={classes['homeform__username']}>
                    <input ref={inputUsernameEl} type="text" placeholder="Your name" required maxLength="12" defaultValue={localStorage.getItem('username') ? localStorage.getItem('username') : ''}></input>
                </div>

                <div className={classes['homeform__email']}>
                    <input ref={inputEmailEl} type="email" placeholder="Your email address" required maxLength="50" defaultValue={localStorage.getItem('email') ? localStorage.getItem('email') : ''}></input>
                </div>

                <div className={classes['homeform__actions']}>
                    <Button isFilled={false}>Start</Button>
                </div>
            </form>

            <br /><br />
            <Button onBtnClick={gotoLeaderboardHandler} >Leaderboard</Button>
            <br /><br /><br /><br />

            {showModal && <Modal onHideModal={hideModalHandler}>
                <Prompt onHideModal={hideModalHandler} title="Select Movie Category" text="Please select Bollywood or Hollywood to start playing." />
            </Modal>}
        </div>
    )
}

export default HomePage;
